import React, { useEffect, useState } from "react";
import "./GameInformation.css";
import "bootstrap/dist/css/bootstrap.css";
import { connect } from "react-redux";
import { Link } from "react-router";
import { API_CONSTANTS } from "../../../utils/constantInformation";
import {
  getCurrentPlatformLeagues,
  getDataForAllPlatformLeague,
  sportsWithLeagues,
  findSportByLeague,
  capitalize,
  getLeagueDisplayName,
  convertToLocalDate,
} from "../../../utils/utils";

import {
  setCompleteGameInformation,
  setHorizontalScrollPosition,
  setInMemoryTimeframes,
  setPlayerSearchedName,
  setPlRes,
  setPositionFilter,
  setTeamFilter,
  setAutoLineupGenBarOpenFlag,
  setPlayerStatus,
  signoutRequest,
  dataRequest,
  dataSuccess,
  dataError,
} from "../../../redux/GameInformation/GameInformationAction";
import {
  setGameInformation,
  setMainPageView,
  goBackBoolean,
  setLeague,
  setMatchDatetime,
  setSelectedTimeframe,
} from "../../../redux/GameInformation/GameInformationAction";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import AutoLineUp from "../AutoLineUp/AutoLineUp";
import { TOUR_STEPS } from "../../Tour/steps/MainScreenStepsLg";
import { TOUR_STEPS_MOB } from "../../Tour/steps/MainScreenStepsMob";

import { fetchDataForPlatformAndLeague } from "../../../utils/apiUtils";

import AppCSS from "../../../assets/app/AppCSS";
import AppJS from "../../../assets/app/AppJS";
import { remoteConfig } from "../../../firebase";
import {
  fetchRemoteConfigFailure,
  fetchRemoteConfigRequest,
  fetchRemoteConfigSuccess,
} from "../../../redux/RemoteConfig/RemoteConfigAction";
import Settings from "./components/Settings";
import LineupModal from "./components/LineupModal";
import DialogTitle from "./components/DialogTitle";
import DialogContent from "./components/DialogContent";
import {
  scrollHorizontal,
  sortByProperty,
} from "./utils";
import { setTime } from "./gameinformationutils";
import Navbar from "./components/Navbar";
import { useIsMobile } from "./hooks/useIsMobile";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2C7BFF",
      dark: "#343A40",
      light: "#F8F9FA",
    },
    secondary: { main: "#6C757D" },
    background: {
      default: "#343A40",
      paper: "#343A40",
    },
  },
});
const CACHE = {};
function GameInformation(props) {
  // Start Experimental
  const [in_memory_timeframe, updateInMemoryTimeframe] = useState(
    props.state_in_memory_timeframe
  );
  // End

  const [complete_game_information, setComplateGameInformation] = useState(
    props.completeGameInformation
  );
  const [timeframe_permanent, setPermanentTimeframe] = useState(
    props.game_information_info.gameInformationReducer.selected_timeframe
  );
  const [gotData, setGotData] = useState(false);

  const [open, setOpen] = useState(false);
  const [modalContent, setModalContent] = useState(
    <div id="modal-content"></div>
  );

  const [currentLeague, setCurrentLeague] = useState(props.currentLeague);

  function initializeLeagueSlates() {

    let leagueSlateInformation = {};

    for (const [sport, leagues] of Object.entries(sportsWithLeagues)) {
      leagueSlateInformation[sport] = {}; // Initialize an object for each sport
      leagues.forEach((league) => {
        leagueSlateInformation[sport][league] = null; // Initialize each league under the sport
      });
    }

    return leagueSlateInformation;
  }

  const [leagueSlates, setLeagueSlates] = useState(initializeLeagueSlates);
  const [tourSteps, setTourSteps] = useState(TOUR_STEPS);
  const isMobile = useIsMobile();
  const [availabe_timeframes, setTimeframes] = React.useState([]);
  const [slates_available, setSlatesForSelectedTimeframe] = React.useState([]);

  useEffect(() => {
    console.log(
      "RRR Updating IN Memory Timeframe",
      props.state_in_memory_timeframe
    );
    updateInMemoryTimeframe(props.state_in_memory_timeframe);
  }, [props.state_in_memory_timeframe]);
  useEffect(() => {
    console.log(
      "RRR Updating Complete Game Information",
      props.completeGameInformation
    );
    setComplateGameInformation(props.completeGameInformation);
  }, [props.completeGameInformation]);

  useEffect(() => {
    setCurrentLeague(props.currentLeague);
  }, [props.currentLeague]);

  useEffect(() => {
    setTourSteps(isMobile ? TOUR_STEPS_MOB : TOUR_STEPS);
  }, [isMobile]);

  useEffect(() => {
    console.log("GameInfoExp useEffect --> GameInformationReducer State ");

    console.log(props.game_information_info.gameInformationReducer);

    // Checking if League is Set
    // If not, open League Selection Modal
    console.groupCollapsed("***** GameInfoExp useEffect *****");
    if (typeof CACHE[leagueSlates] !== typeof undefined) {
      console.log("Returning from CACHE: ");
      console.log(CACHE[leagueSlates]);
      setLeagueSlates(CACHE[leagueSlates]);
      if (currentLeague !== null) {
        console.log("Current Non Null League: ", currentLeague);
        setModalContent(getLeagueSlates(currentLeague));
      } else {
        setModalContent(getLeagues());
      }
      if (props.game_information_info.gameInformationReducer.sports === null) {
        console.log("-- Inside Open League Modal --");
        handleClickOpen().then(() => {
          setModalContent(getLeagues());
        });
      }
    }

    const fetchData = async () => {
      const isAdmin = props.isAdmin;
      await getDataForAllPlatformLeague("dream11", isAdmin, props.remoteConfig)
        .then((result) => {
          console.log("League Data: ", result);
          CACHE[leagueSlates] = result;
          setLeagueSlates(result);
          setGotData(true);
        })
        .catch((error) => {
          console.log(
            "ERROR: failed fetchData : ", error,
            getDataForAllPlatformLeague("dream11", isAdmin, props.remoteConfig)
          );
        });
      console.log(
        "GameInformation Reducer: (after fetching Data from League API) ",
        props.game_information_info.gameInformationReducer
      );
      console.log("GameInfoExp Timeframe Permanent: ", timeframe_permanent);
    };
    fetchData().then(() => {
      if (currentLeague !== null) {
        console.log("Current Non Null League: ", currentLeague);
        setModalContent(getLeagueSlates(currentLeague));
      } else {
        setModalContent(getLeagues());
      }
    });

    if (props.game_information_info.gameInformationReducer.sports === null) {
      console.log("-- Inside Open League Modal --");
      handleClickOpen().then(() => {
        setModalContent(getLeagues());
      });
    }
    console.log(
      "GameInformation Reducer --> sports , Go_back_boolean, view_selected: ",
      props.game_information_info.gameInformationReducer.sports,
      props.game_information_info.gameInformationReducer.go_back_boolean,
      props.game_information_info.gameInformationReducer.view_selected
    );

    console.groupEnd();
  }, [
    currentLeague,
    gotData,
    props.game_information_info.gameInformationReducer.sports,
    // showAutoLineUpComponent,
  ]);

  // ---------------------------------------- Needed Functions Begin ------------------------------------- //

  function getLeagues() {
    console.log("getLeagues");
    const currentPlatorm = "dream11"; // TODO: make generic when we support multiple platforms
    const isAdmin = props.isAdmin;
    const currentLeagues = getCurrentPlatformLeagues(
      currentPlatorm,
      isAdmin,
      props.remoteConfig
    );
    console.log("getLeagues -- ", currentLeagues);
    console.log("getLeagues --> League Slates: ", leagueSlates);
    currentLeagues.map((sportData) => console.log("SportData", sportData));

    return (
      <>
        <AppJS />
        <AppCSS />
        <div className="accordion" id="sportsAccordion">
          {currentLeagues.map((sportData, index) => (
            <div key={index}>
              <h2 className="m-2 p-2">
                <button
                  className="btn text-white bg-secondary btn-block text-left"
                  type="button"
                  data-toggle="collapse"
                  data-target={`#collapse${index}`}
                  aria-expanded="true"
                  aria-controls={`collapse${index}`}
                >
                  {sportData.name}
                </button>
              </h2>

              <div
                id={`collapse${index}`}
                className="collapse"
                aria-labelledby={`heading${index}`}
                data-parent="#sportsAccordion"
              >
                <ul className="list-group m-2 p-2 text-white bg-dark">
                  {sportData.leagues.map((leagueData) => (
                    <li
                      class="list-group-item m-2 p-2  bg-dark"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        handleSetCurrentLeague(
                          e,
                          leagueData.name.toUpperCase()
                        );
                      }}
                      key={getLeagueDisplayName(leagueData.name, isAdmin, props.remoteConfig)}
                    >
                      {getLeagueDisplayName(leagueData.name, isAdmin, props.remoteConfig)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
        <div className="pl-2 pr-2 d-flex flex-row-reverse align-items-end w-100 align-self-end">
          <p className="text-secondary">
            <i>
              <small>More League Support Coming Soon</small>
            </i>
          </p>
        </div>
      </>
    );
  }

  function handleSetCurrentLeague(e, league) {
    e.preventDefault()
    setCurrentLeague(league); //state update
    props.updateLeague(league); //redux update
    console.log(
      "GameInformation Reducer --> Sports (After handling setCurrentLeague): ",
      props.game_information_info.gameInformationReducer.sports
    );
    console.log("handleSetCurrentLeague --> league: ", league);

    setModalContent(getLeagueSlates(league));
  }

  function getLeagueSlates(league) {
    console.groupCollapsed("-- getLeagueSlates --");
    console.log("Selected league: ", league);
    if (league !== undefined && league !== null) {
      let sport = findSportByLeague(league, props.remoteConfig, "GIEXP: getLeagueSlates");
      sport = capitalize(sport);
      if (!sport) {
        console.error("League not found in any sport");
        return;
      }
      try {
        const result = leagueSlates[sport][league.toUpperCase()];
        if (!result) {
          return no_slate_available(league)
        };
        setComplateGameInformation(result);
        props.updateAPIResult(result);

        console.log("Complete Game Information: ");
        console.log(result);
        var time_frames = [];
        var temp_check = [];

        result.forEach((el) => {
          console.log("Result EL: ", el);
          const localGameDate = convertToLocalDate(el.GameDateTime);

          if (temp_check.indexOf(localGameDate) === -1) {
            time_frames.push({
              slate_id: el.SlateID,
              slate_timeframe: localGameDate, // Now using formatted local game date
            });
            temp_check.push(localGameDate);
          } else {
            console.error("### TimeFrames EMPTY..! ####");
          }
        });

        updateInMemoryTimeframe(time_frames);
        props.changeInMemoryTimeframe(time_frames);
        console.log("Time Frames: ", time_frames);
        console.log("Temp Check: ", temp_check);
        setTimeframes(time_frames);

        const slate_for_selected_timeframe = result.filter((el) => {
          return convertToLocalDate(el.GameDateTime) === time_frames[0].slate_timeframe;
        });

        console.log("Slate for selected timeframe: ", slate_for_selected_timeframe);
        setSlatesForSelectedTimeframe(slate_for_selected_timeframe);
        console.groupEnd();
        return populate_slate_for_selected_timeframe(
          time_frames,
          slate_for_selected_timeframe[0].slate_timeframe
        );
      } catch (error) {
        console.error("Error: GameInfoExp --> Get League Slates: ", error);
      }
    }
  }

  function no_slate_available(league) {
    return (
      <div className="no-slate-status-container">
        <h5 className="no-slate-status-title">
          No Slates For {league}
        </h5>
        <h6 className="no-slate-status-subtitle">
          Please check internet or refresh the website to get slates for {league}
        </h6>
      </div>
    );
  }

  function populate_slate_for_selected_timeframe(
    time_frames,
    selected_timeframe
  ) {
    console.log("HCO GIXP: Timeframe: ", time_frames, selected_timeframe);
    console.log(
      "HCO time_frames insiede populate_slate_for_selected_timeframe: ",
      time_frames
    );
    let slate_for_selected_timeframe = null;
    try {
      if (currentLeague !== undefined && currentLeague !== null) {
        const sport = findSportByLeague(
          currentLeague,
          props.remoteConfig,
          "populate_slate_for_selected_timeframe"
        );
        console.log("HCO GIXP: League Slates: ", leagueSlates);
        console.log("HCO GIXP: Current league: ", currentLeague);
        console.log("HCO GIXP: Data", leagueSlates[sport][currentLeague]);

        const currentLeagueSlates = leagueSlates[sport][currentLeague];

        slate_for_selected_timeframe = currentLeagueSlates.filter((el) => {
          return convertToLocalDate(el.GameDateTime) == selected_timeframe;
        });
      }
    } catch (error) {
      console.log(
        "HCO GIXP ERROR: GameInfoExp --> Populate Slates for Timeframe: ",
        error
      );
    }

    console.log("-- After Populate Slate from time_frame --");
    console.log("HCO Time Frames: ", time_frames);
    console.log("HCOSelected time frame: ", selected_timeframe);
    console.log("HCO League slates: ", leagueSlates);

    console.log(
      "HCO GIXP: Slate for selected time_frame: ",
      slate_for_selected_timeframe
    );
    try {
      console.log("HCO GIXP: Time_frames inside try block: ", time_frames);
      console.log(
        "HCO GIXP: : ",
        slate_for_selected_timeframe,
        slate_for_selected_timeframe.length
      );

      return slate_for_selected_timeframe.length > 0 ? (
        <>
          <div className="bg-black" id="modal-content">
            <div className="bg-black border-bottom border-dark">
              <ul
                className="step-scroll-list-horizontal scrolling-wrapper list-group list-group-horizontal"
                id="ul-horizontal-scroll"
                onWheel={(e) => scrollHorizontal(e)}
              >
                {time_frames.map((game_timeframe, index) => (
                  <li
                    className={`btn ${selected_timeframe === game_timeframe.slate_timeframe
                      ? "btn-primary"
                      : "btn-secondary"
                      } m-2 text-nowrap`}
                    onClick={() =>
                      setNewTimeFrame(game_timeframe.slate_timeframe)
                    }
                    key={index}
                  >
                    {displayDateFromSlateTimeFrame(
                      game_timeframe.slate_timeframe
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-black">
              <div className="container-fluid bg-black">
                <input type="hidden" className="slate-hidden-element"></input>
                {slate_for_selected_timeframe
                  .sort(sortByProperty("GameDateTime"))
                  .map((slate, index) => (
                    <div
                      key={slate.SlateGameID}
                      className="card m-1 p-0 bg-secondary"
                      data-dismiss="modal"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        saveAllSelections(slate.SlateGameID, slate.Date);
                      }}
                    >
                      <div className="slate-card-1 card-body m-1 p-0">
                        <div className="d-flex justify-content-between m-0 p-0">
                          <div className="m-0 p-0">
                            <p className="text-white m-0">
                              <b>{setTime(slate.GameDateTime)}</b>
                            </p>
                            <p className="m-0">DailyFantasy</p>
                            <div className="border border-white rounded">
                              <p className="p-2 m-0">
                                {slate.Team} vs {slate.Opponent}
                              </p>
                            </div>
                          </div>
                          <div>
                            <p className="text-red">
                              <b>Announced</b>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>slate is of length 0</div>
      );
    } catch (error) {
      console.error(
        "GIXP: Error: GameInfoExp --> Populate Slate for Timeframe: ",
        error
      );
      return <div>some other error</div>;
    }
  }

  function handleBreadcrumbClick(event) {
    event.preventDefault();
    setModalContent(getLeagues());
  }
  function handleBreadcrumbPlatformClick(event) {
    event.preventDefault();
    alert("More Platform support coming soon");
  }

  function displayTitleRow() {
    const isAdmin = props.isAdmin
    return (
      <div className="">
        <Breadcrumbs
          separator={
            <NavigateNextIcon fontSize="medium" className="text-white" />
          }
          aria-label="breadcrumb"
        >
          <Link
            className=" btn btn-outline-primary font-weight-bold"
            data-toggle="tooltip"
            data-placement="top"
            title=""
            href="/"
            onClick={handleBreadcrumbPlatformClick}
          >
            Dream 11
          </Link>

          {props.game_information_info.gameInformationReducer.sports ? (
            <Link
              href="/getting-started/installation/"
              onClick={handleBreadcrumbClick}
            >
              <Typography className=" btn btn-outline-primary font-weight-bold">
                {getLeagueDisplayName(props.game_information_info.gameInformationReducer.sports, isAdmin, props.remoteConfig)}
              </Typography>
            </Link>
          ) : null}
        </Breadcrumbs>
      </div>
    );
  }

  const handleClickOpen = async () => {
    // fetch slates for given platform and league and set variables
    console.log("HCO Handle click open called");
    const fetchConfig = () => {
      console.log("Fetch Config Called");
      props.fetchConfigRequest();
      remoteConfig
        .fetchAndActivate()
        .then(() => {
          console.log("Fetch And Activate Complete");
          const configValues = remoteConfig.getAll();
          props.fetchConfigSuccess(configValues);
        })
        .catch((error) => {
          props.fetchConfigFailure(error);
          console.log("Fetch And Activate Failed");
        });
    };

    fetchConfig();
    const platform =
      props.game_information_info.gameInformationReducer.platform;
    const league = props.game_information_info.gameInformationReducer.sports;

    console.log("HCO platform:: ", platform, "league:: ", league);

    if (league !== undefined && league !== null) {
      const sport = findSportByLeague(
        league,
        props.remoteConfig,
        "GIEXP: handle click open"
      );
      console.log(
        "HCO platform:: ",
        platform,
        "league:: ",
        league,
        "sport:: ",
        sport
      );
      fetchDataForPlatformAndLeague(platform, sport, league)
        .then((result) => {
          const selected_timeframe = result[0]["slate_timeframe"];
          console.log(
            "HCO HANDLE CLICK OPEN RESULT",
            result,
            selected_timeframe
          );
          populate_slate_for_selected_timeframe(result, selected_timeframe);
          setOpen(true);
        })
        .catch((e) => {
          console.log("HCO " + e);
          console.log(e);
          setOpen(true);
        });
    } else {
      console.log("HCO League not undefined");
      setOpen(true);
    }

    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function setNewTimeFrame(timeframe) {
    console.log("HCO Set new timeframe: ", timeframe);
    const available_slates = complete_game_information.filter((el) => {
      return el.slate_timeframe == timeframe;
    });
    console.log("HCO Available Slates: ", available_slates);
    setPermanentTimeframe(timeframe);
    console.log("HCO In memory timeframe: ", in_memory_timeframe);
    setModalContent(
      populate_slate_for_selected_timeframe(props.state_in_memory_timeframe, timeframe)
    );
  }

  function saveAllSelections(slate_id, date) {
    try {


      props.dataRequest();
      console.log(
        "Save all selections --> slate Id, timeFame_permanent, date: ",
        slate_id,
        timeframe_permanent,
        date
      );
      console.log("Save all selections --> Current_League: ", currentLeague);
      if (timeframe_permanent === null) {
      }

      console.log("::::Timeframe_permanent", timeframe_permanent);
      let game_info = {
        platform: "dream11",
        sports: currentLeague,
        selected_timeframe: date,
        slate_id: slate_id,
      };
      // TODO: we may need to revert it to local complete_game_information state variable
      setPermanentTimeframe(date);
      props.game_information(game_info);
      props.updateLeague(currentLeague);
      const slateDatetime = props.completeGameInformation.filter((el) => {
        return el.SlateGameID == slate_id;
      });
      console.log("RRR slateDateTime: ", slate_id, props.completeGameInformation, slateDatetime)
      // setting defaults

      props.updateSearchString("");
      props.update_filtered_team("Both");
      props.updatePosition("ALL");
      // here reset the player status redux state too
      props.update_player_status(API_CONSTANTS.NULL_CONSTANT);
      console.log(
        "Time to set for countdown timer: ",
        slate_id,
        slateDatetime,
        props.completeGameInformation,
        slateDatetime.GameDateTime
      );
      props.set_datetime_for_countdown(slateDatetime[0].GameDateTime);
      handleClose();
      props.dataSuccess();
    } catch (e) {
      console.log("GameInformationExp Error : ", e)
    }
  }

  // ---------------------------------------- Needed Functions End ------------------------------------- //

  // ----------------- Open & Close Methods for League Modal ----------------------- //

  function displayDateFromSlateTimeFrame(slateDate) {
    const date = new Date(slateDate);
    const last2 = date.getFullYear().toString().substring(2);

    // alert("")

    return (
      date.toDateString().split(" ")[0] +
      " " +
      date.getDate() +
      "/" +
      parseInt(date.getMonth() + 1) +
      "/'" +
      last2
    );
  }

  return (
    <>
      <AppJS />
      <AppCSS />
      {props.game_information_info.gameInformationReducer
        .auto_lineup_gen_bar_open_flag ? (
        <AutoLineUp />
      ) : (
        <></>
      )}
      <Navbar handleClickOpen={handleClickOpen} />
      {/* ---------------------Main Modal------------------------------         */}

      <div>
        <ThemeProvider theme={theme}>
          <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            className="content w-100"
          >
            <DialogTitle
              className=""
              id="customized-dialog-title"
              onClose={handleClose}
            >
              {displayTitleRow()}
            </DialogTitle>
            <DialogContent
              dividers
              id="modal-content"
              modalContent={modalContent}
            />
          </Dialog>
        </ThemeProvider>
      </div>

      {/* Lineup Modal */}
      <LineupModal props={props} remoteConfig={props.remoteConfig} />
      {/* Settings Modal */}
      <Settings tourSteps={tourSteps} userEmail={props.userEmail} />
    </>
  );
}

const mapStateToProps = (state) => {
  console.log(
    "Updated State Values: Complete Game: ",
    state.gameInformationReducer.complete_game_information,
    "In Memory Timeframe",
    state.gameInformationReducer.in_memory_timeframe
  );
  return {
    game_information_info: state,
    completeGameInformation:
      state.gameInformationReducer.complete_game_information,
    currentLeague: state.gameInformationReducer.sports,
    state_in_memory_timeframe: state.gameInformationReducer.in_memory_timeframe,
    state_horizontal_scroll_position:
      state.gameInformationReducer.horizontal_scroll_position,
    remoteConfig: state.rcReducer,
    loading: state.gameInformationReducer.loading,
    error: state.gameInformationReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // START EXPERIMENT
    changeInMemoryTimeframe: (value) => dispatch(setInMemoryTimeframes(value)),
    changeHorizontalScrollPosition: (value) =>
      dispatch(setHorizontalScrollPosition(value)),
    // END EXPERIMENT

    updateAPIResult: (value) => dispatch(setCompleteGameInformation(value)),
    updateLeague: (value) => dispatch(setLeague(value)),
    game_information: (value) => dispatch(setGameInformation(value)),
    update_filtered_team: (value) => dispatch(setTeamFilter(value)),
    view_setter: (value) => dispatch(setMainPageView(value)),
    go_back_boolean: (value) => dispatch(goBackBoolean(value)),
    set_datetime_for_countdown: (value) => dispatch(setMatchDatetime(value)),
    set_selected_timeframe: (value) => dispatch(setSelectedTimeframe(value)),
    set_match_datetime: (value) => dispatch(setMatchDatetime(value)),
    updatePosition: (value) => dispatch(setPositionFilter(value)),
    updateFantasyResponsibility: (value) => dispatch(setPlRes(value)),
    updateSearchString: (value) => dispatch(setPlayerSearchedName(value)),
    update_auto_lineup_generation_flag: (value) =>
      dispatch(setAutoLineupGenBarOpenFlag(value)),
    update_player_status: (value) => dispatch(setPlayerStatus(value)),
    reset_state: () => dispatch(signoutRequest()),
    dataRequest: () => dispatch(dataRequest()),
    dataSuccess: () => dispatch(dataSuccess()),
    dataError: (error) => dispatch(dataError(error)),
    fetchConfigRequest: () => dispatch(fetchRemoteConfigRequest()),
    fetchConfigSuccess: (configValues) =>
      dispatch(fetchRemoteConfigSuccess(configValues)),
    fetchConfigFailure: (error) => dispatch(fetchRemoteConfigFailure(error)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(GameInformation);
